import React from "react";

// import notification
import { notification, Button } from "antd";

export const notificationStyle = {
  marginTop: "0",
};

export const deleteNotificationStyle = {
  width: "420px",
  // change this value to adjust the distance from the top
};

export const Notification = (type, message, description) => {
  notification[type]({
    message,
    description,
    placement: "topRight",
    duration: 3,
    style: notificationStyle,
  });
};

export const handleDeleteWithIdConfirmation = (deleteFunction, Id) => {
  notification.warning({
    message: "Are you sure you want to delete this item?",
    description:
      "This action cannot be undone, and item would be removed permanently!",
    duration: null,
    onClose: () => {},
    onClick: () => {},
    style: deleteNotificationStyle,
    key: "deleteConfirmation",
    btn: (
      <Button
        onClick={() => {
          notification.destroy("deleteConfirmation");
          deleteFunction(Id);
        }}
        type="primary"
        ghost
        danger
      >
        Delete
      </Button>
    ),
  });
};

export const handleOpertaionConfirmation = (performOperation,dto,pestID,updateForm,resetStates) => {
  notification.warning({
    message: "Are you sure you want to change the threshold type for this pest?",
    description:
      "Changing the threshold type will delete all related thresholds. This action is irreversible!",
    duration: null,
    onClose: () => {},
    onClick: () => {},
    style: deleteNotificationStyle,
    key: "confirmation",
    btn: (
      <Button
        onClick={async () => {
          notification.destroy("confirmation");
          try{
            await performOperation(dto).unwrap();
             Notification(
              "success",
              "Operation Successful",
              "The threshold type was changed successfully."
            );
           updateForm.resetFields();
          console.log(updateForm.getFieldsValue()) 
           resetStates();
           window.location.reload();

        
            }catch(error){
              Notification(
                "error",
                "Operation Failed",
                `${error.data?.message || error.data?.title || error?.data}`
              );

              console.log(error)
            }
          
        }}
        type="primary"
        ghost
        primary
      >
        Change Threshold
      </Button>
    ),
  });
};

export const handleDeleteConfirmation = (deleteFunction) => {
  notification.warning({
    message: "Are you sure you want to delete this item?",
    description: "This action cannot be undone.",
    duration: null,
    onClose: () => {},
    onClick: () => {},
    style: deleteNotificationStyle,
    key: "deleteConfirmation",
    btn: (
      <Button
        onClick={() => {
          notification.destroy("deleteConfirmation");
          deleteFunction();
        }}
        type="primary"
        ghost
        danger
      >
        Delete
      </Button>
    ),
  });
};
